import { createApi } from "@reduxjs/toolkit/query/react";
import { apiSliceInterceptor } from "stores/redux/apiSliceInterceptor";

const Client = createApi({
  reducerPath: "Client",
  baseQuery: apiSliceInterceptor.baseQueryWithInterceptor,
  tagTypes: ["GETCLIENTLIST", "ADDUSER", "UPDATEUSER"],

  endpoints: (qb) => ({
    // GET
    getClientListApi: qb.query({
      query: (filters) => {
        const { role, isActive, page, limit, noGlobalLoading = true } = filters || {};
        const params = { page, limit, noGlobalLoading };
    
        if (role) params.role = role;
    
        // ✅ Fix here: allow both true and false
        if (typeof isActive === "boolean") {
          params.isActive = isActive;
        }
    
        return {
          url: `api/user/users-by-role`,
          params,
        };
      },
      transformResponse: (response) => {
        console.log("API Response:", response);
        return response;
      },
      providesTags: ["GETCLIENTLIST"],
    }),
    

    resetPasswordApi: qb.mutation({
      query: (formData) => ({
        url: `api/user/reset-password`,
        method: "POST",
        body: {
          userId :formData.userId,
          confirmPassword:formData.confirmPassword,
          password: formData.password,
        },
      }),
      invalidatesTags: ["ADDUSER"],
    }),

    // ADD Client
    addClientApi: qb.mutation({
      query: (formData) => ({
        url: `api/user/register`,
        method: "POST",
        body: {
          role: "CLIENT",
          name: formData.name,
          companyName: formData.companyName,
          email: formData.email,
          mobile: formData.mobile,
          secondaryMobile: formData.secondaryMobile,
          regNo: formData.regNo,
          password: formData.password,
          address: formData.address,
          category: formData.category,
          driver: Number(formData.driver),
          paylonCode: formData.paylonCode,
          favouriteProductIds: formData.favouriteProducts,
          orderStartTime: formData.orderStartTime,
          orderEndTime: formData.orderEndTime,
          status:formData.isActive,
          extraInfo:formData.extraInfo
        },
      }),
      invalidatesTags: ["ADDUSER"],
    }),
    

    // UPDATE Client
    updateClientApi: qb.mutation({
      query: (formData) => ({
        url: `api/user/${formData.id}`,
        method: "PUT",
        body: {
          role: "CLIENT",
          status:formData.isActive,
          name: formData.name,
          companyName: formData.companyName,
          email: formData.email,
          mobile: formData.mobile,
          secondaryMobile: formData.secondaryMobile,
          regNo: formData.regNo,
          password: formData.password,
          address: formData.address,
          category: formData.category,
          driver: Number(formData.driver),
          paylonCode: formData.paylonCode,
          favouriteProductIds: formData.favouriteProducts, // 👈 this matches addClientApi
          orderStartTime: formData.orderStartTime,
          orderEndTime: formData.orderEndTime,
          extraInfo:formData.extraInfo,
        },
      }),
      invalidatesTags: ["UPDATEUSER"],
    }),
    
    
  }),
});

export const ClientsApiReducer = Client.reducer;

export const clientsApiAction = {
  middleware: Client.middleware,
  reducerPath: Client.reducerPath,
  getClientListApi: Client.useGetClientListApiQuery,
  resetPasswordApi:Client.useResetPasswordApiMutation,
  addClientApi: Client.useAddClientApiMutation,
  updateClientApi: Client.useUpdateClientApiMutation,
};
